import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

import App from '@/components/core/App.vue';
import moment from 'moment';
import AppRouter from './router/index';
import SessionVerificationService from './services/SessionVerification';

Vue.config.productionTip = false;
Vue.use(Vuex);

const config = require('./config');

const router = AppRouter();

const vuexLocalStorage = new VuexPersist({
  key: 'vuex',
  storage: window.localStorage,
});
const store = new Vuex.Store({
  state: {
    user: null,
    session: null,
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    clearUser(state) {
      state.user = null;
    },
    setSession(state, session) {
      state.session = session;
    },
    clearSession(state) {
      state.session = null;
      store.commit('clearUser');
    },
  },
  plugins: [vuexLocalStorage.plugin],
});

Vue.filter('unixDate', (value) => value && moment.unix(value).utcOffset(60).format('ddd, DD/MM/YY (HH:mm)'));
Vue.filter('prettyDate', (value) => value && moment.unix(value).utcOffset(60).format('HH:mm, Do MMM YYYY'));
Vue.filter('commaFormat', (value) => value && value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));

Vue.filter('msTime', (value) => {
  if (!value) {
    return value;
  }
  const duration = moment.duration(value, 'ms');
  return (
    // eslint-disable-next-line no-nested-ternary
    duration.hours() > 10
      ? `${duration.hours()}:`
      : duration.hours() > 0
        ? `0${duration.hours()}:`
        : ''
  ) + moment.utc(duration.asMilliseconds()).format('mm:ss:SS');
});

Vue.filter('time', (value) => {
  if (!value) {
    return value;
  }

  const duration = moment.duration(value, 'seconds');
  return (
    // eslint-disable-next-line no-nested-ternary
    duration.hours() > 10
      ? `${duration.hours()}:`
      : duration.hours() > 0
        ? `0${duration.hours()}:`
        : ''
  ) + moment.utc(duration.asMilliseconds()).format('mm:ss.SSS');
});

Vue.filter('stripColor', (value) => {
  if (!value) {
    return value;
  }

  let newValue = value;
  while (newValue.match(/\^[0-9]/g)) {
    newValue = newValue.replace(/\^[0-9]/g, '');
  }
  return newValue;
});

Vue.mixin({
  data() {
    return {
      get global_siteName() {
        return config.siteName;
      },
      get global_authUri() {
        return config.authUri;
      },
    };
  },
  methods: {
    async global_verifySession(loginKey, ip, callback = null) {
      const session = await SessionVerificationService.verify(loginKey, ip);
      if (session.data.success) {
        this.$store.commit('setSession', session.data);
      } else {
        this.$store.commit('clearSession');
      }
      if (callback) {
        callback(session.data);
      }
    },
  },
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
});
